import {ID_VERIFICATION_STATUS} from '../../../../oauth/oauth_const';
import TimeSpan from '../../../../../utils/time_span';
import OptionsComponentController from '../../../../../components/options/options_component_controller';
import COMBaseRegulation from "../com_base_regulation";

interface AccountData {
    IdVerificationStatus: number,
    AddressVerificationStatus: number
}

export default class UKRegulation extends COMBaseRegulation {
    static CLASS = 'UKRegulation';

    private _getAccountData(): AccountData {
        return this.serviceFactory.userService().getAccountData() as AccountData;
    }

    isAnonymousPlayAllowed() : boolean {

        if(!this.serviceFactory.oAuth2Service().isAuthorized()) {
            return false;
        }

        return this._getAccountData().IdVerificationStatus === ID_VERIFICATION_STATUS.AGE_VERIFIED;
    }

    forceDemoButton(): boolean {

        return this.isAnonymousPlayAllowed() && this._getAccountData().AddressVerificationStatus !== ID_VERIFICATION_STATUS.ADDRESS_VERIFIDED;
    }

    protected realityCheckEnabled(): boolean {
        return true;
    }

    getRealityCheckInterval(): TimeSpan {
        return this.serviceFactory.componentFactoryService().createComponent(OptionsComponentController).getReminderInterval();
    }

    getRealityCheckIntervalExpectedByTheGame() {
        let interval = this.getRealityCheckInterval();
        return {
            timeSpan: interval,
            expectedValueByTheGame: Math.round(interval.totalSeconds)
        }
    }

    shouldHaveBetLimitsPerBrand(): boolean {
        return true;
    }

    showNetPosition(): boolean {
        return true;
    }
}